import {userProfile} from '@netx/core-user/collections/singletons/userProfile';

export const getUserId = () => userProfile.id;

export default getUserId;
